module.exports = __webpack_public_path__ + "img/Paso1Check.09945ba2.svg";